import Box20 from '@carbon/icons-react/es/box/20';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { ArchivedProjects } from 'components/organisms/archived-projects';
import { useTranslation } from 'hooks/use-translation';

export const ArchivedProjectsPage: FC = () => {
  const title = useTranslation('project.archived_projects.title');

  return (
    <Page>
      <Page.Header
        $white
        sticky
        title={<HeaderWithIconTitle icon={<Box20 />} title={title} />}
      />
      <Page.Content>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <ArchivedProjects />
      </Page.Content>
    </Page>
  );
};
